"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTrailingWhitespace = void 0;
function removeTrailingWhitespace(string) {
    return string.replace(/^\s+|\s+$/g, "").replace("\n", "");
}
exports.removeTrailingWhitespace = removeTrailingWhitespace;
